// Modal.jsx
import { useEffect } from "react";
import { createPortal } from "react-dom";
import { motion as Motion, AnimatePresence } from "framer-motion";

export default function TransferirTicket({ isOpen, onClose, large, children }) {
  // Bloquear scroll del body cuando esté abierto
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => (document.body.style.overflow = "");
  }, [isOpen]);

  // Cerrar con tecla ESC
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  return createPortal(
    <AnimatePresence>
      {isOpen && (
        <Motion.div
          key="transferir-ticket"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose} // Cerrar si clic fuera del contenido
          className="fixed inset-0 z-[100] bg-aw-bluedark-50 flex items-center justify-end"
        >
          <Motion.div
            initial={{ bottom: "-100%", opacity: 0 }}
            animate={{ bottom: "0%", opacity: 1 }}
            exit={{ bottom: "-100%", opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            className={`bg-transparent shadow-lg py-6 ${large} w-full h-[60dvh] relative`}
            onClick={(e) => e.stopPropagation()} // Evita cerrar si clic en el contenido
          >
            {/* Botón de cerrar */}
            {/* <button
              onClick={onClose}
              className="absolute top-8 right-9 text-aw-bluedark hover:text-gray-500 font-semibold duration-300 transition-text z-50"
              aria-label="Cerrar modal"
            >
              ✕
            </button> */}
            {children}
          </Motion.div>
        </Motion.div>
      )}
    </AnimatePresence>,
    document.body
  );
}
